import { useMutation } from "@tanstack/react-query";
import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal"; import { postRequest } from "../services/apiMethods";
import { Link } from "react-router-dom";


const SubscriptionDetailsModal = ({ subscriptionModalShow, handleSubscriptionClose, idSelect }) => {
  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest("/lead/subscription", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        window.location.href = `${data?.data?.url}`;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });



  const handleSubscribe = () => {
    const payload = {
      priceId: "price_1RbJRRGsWFp7wx9jCGAU3uHS",
      leadId: idSelect
    };
    mutate(payload);

  }

  const handlePrimeSubscription = (id) => {
    const payload = {
      priceId: "price_1RbJQzGsWFp7wx9jUiCEguuy",
      leadId: idSelect
    };
    mutate(payload);
  };



  return (
    <Modal size="lg" show={subscriptionModalShow} onHide={handleSubscriptionClose}>
      <Modal.Body>
        <div>
          <div className="account-created-pop">
            {/* <h3>You need a quote subscription pack to contact Tony</h3> */}
            <p>
    
              To respond to this lead, you’ll need a subscription.
              <br /> Your first 3 months are free — cancel anytime.

            </p>
          </div>
          <Row>
            <Col lg={10} className="mx-auto">
              <div className="faq-list-accro">
                <Accordion flush>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>What are quote credits?</Accordion.Header>
                    <Accordion.Body>
                      <span> Quote credits are used to respond to jobs.</span>
                      <br />
                      <span> Each lead costs 1 quote credit — simple. </span>
                      <br />
                      <span> You’ll receive quote credits each month as part of your subscription.</span>
                      <br />
                      <span>Need more? You can always purchase additional credits.</span>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Can I cancel my subscription?</Accordion.Header>
                    <Accordion.Body>
                      Yes, you can cancel your subscription at any time. There are no long-term commitments.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <div className="my-profile-box-form position-relative">
                <div className="offer-label-tag">
                  <ul>
                    <li> New Member Offer</li>
                    <li>3 month trial</li>
                  </ul>
                </div>
                <div className="credits-list">
                  <div class="form-box-title-quotes">
                    <div>

                      <h4>5 Free quotes</h4>
                      <p >Per Month</p>
                    </div>
                  </div>
                  <div>
                    <h4 className="">3 month free trial</h4>
                    <h6>then just £80.00 for 10 quotes</h6>
                  </div>
                  <div>
                    <button className="theme-comm-btn" onClick={handleSubscribe}>Subscribe</button>
                    {/* <button className="theme-comm-btn" onClick={()=> handleSubscription("price_1Qx04UGsWFp7wx9j8s82OKAB") }>Prime Subscribe</button> */}
                  </div>
                </div>
              </div>


              <div className="my-profile-box-form position-relative">

                <div className="credits-list">
                  <div class="form-box-title-quotes">
                    <div>
                      <h4>20 quotes</h4>
                      <p >Per Month</p>
                    </div>
                  </div>
                  <div>
                    <h4 className="mt-2">£120.00 Per Month </h4>
                
                  </div>
                  <div>
                    <button className="theme-comm-btn" onClick={() => handlePrimeSubscription("price_1RbJQzGsWFp7wx9jUiCEguuy")}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M19.1812 7.65313L17.0406 15.8938C16.9783 16.1324 16.8388 16.3437 16.6437 16.4946C16.4487 16.6456 16.2091 16.7277 15.9625 16.7281H4.03747C3.79083 16.7277 3.55128 16.6456 3.35624 16.4946C3.16119 16.3437 3.02163 16.1324 2.95935 15.8938L0.81872 7.65313C0.766654 7.45477 0.770364 7.24589 0.829443 7.04951C0.888522 6.85313 1.00067 6.67687 1.15354 6.54016C1.3064 6.40346 1.49405 6.31161 1.69578 6.27475C1.89752 6.23789 2.10551 6.25744 2.29685 6.33125L5.84372 7.69688C5.87959 7.71082 5.91899 7.71289 5.95612 7.70276C5.99325 7.69264 6.02615 7.67086 6.04997 7.64063L9.12185 3.70313C9.2255 3.56887 9.35855 3.46017 9.51078 3.38538C9.66301 3.31059 9.83036 3.2717 9.99997 3.2717C10.1696 3.2717 10.3369 3.31059 10.4892 3.38538C10.6414 3.46017 10.7744 3.56887 10.8781 3.70313L13.95 7.64063C13.9738 7.67086 14.0067 7.69264 14.0438 7.70276C14.0809 7.71289 14.1204 7.71082 14.1562 7.69688L17.7031 6.33125C17.8943 6.26064 18.1012 6.24346 18.3015 6.28155C18.5018 6.31965 18.6879 6.41159 18.8399 6.54749C18.9918 6.68339 19.1039 6.85812 19.164 7.05292C19.2242 7.24771 19.2301 7.45521 19.1812 7.65313Z" fill="white" />
                      </svg>
                      <span className="m-1">Subscribe
                        </span></button>
                  </div>
                </div>
              </div>
              <div className="terms-con-txt">
                <Link to="/terms-and-conditions" target="_blank" className="term-policy">
                  See our Terms & Conditions
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SubscriptionDetailsModal
